export function fromStorage(key) {
    return localStorage.getItem(key);
}

export function deleteFromStorage(key) {
    localStorage.removeItem(key);
}

export function setStorage(key, value) {
    localStorage.setItem(key, value);
}

export function fromSessionStorage(key) {
    return sessionStorage.getItem(key);
}

export function deleteFromSessionStorage(key) {
    sessionStorage.removeItem(key);
}

export function setSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
}
